import { ReactElement } from 'react';

import { WaitlistEntryCancelAppointmentCommand } from '@dreryk/egabinet-waitlist-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { AppointmentInvalidTransitionFault } from '@dreryk/egabinet-appointment-frontend-api';

import {
   ButtonVariant,
   dispatchSnackbarNegativeEvent,
   dispatchSnackbarPositiveEvent,
   ModalConfirmButton,
} from '@dreryk/react-components';
import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { translationKeys } from '../translations';

type VisitCancelNotConfirmedAndPatientSuspendModalConfirmButtonProps = {
   appointmentId: number;
   onSuccess?: VoidFunction;
};

export const VisitCancelNotConfirmedAndPatientSuspendModalConfirmButton = (
   props: VisitCancelNotConfirmedAndPatientSuspendModalConfirmButtonProps
): ReactElement => {
   const { executeAsync: cancelAndSuspendPatient } = useCqrsCommand<void, void, AppointmentInvalidTransitionFault>(
      () => {
         const command = new WaitlistEntryCancelAppointmentCommand();
         command.appointmentId = AppointmentId.of(props.appointmentId);
         command.targetStatus = 'SUSPENDED';
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.successfullyCancelledAndSuspendedFromWaitlist);
            props.onSuccess?.();
         },
         onFault: {
            'egabinet-appointment-frontend-api:AppointmentInvalidTransitionFault': () => {
               dispatchSnackbarNegativeEvent(translationKeys.visitAlreadyCancelled);
            },
         },
      }
   );
   return (
      <ModalConfirmButton
         variant={ButtonVariant.SECONDARY}
         testId={'cancelAndSuspend'}
         label={translationKeys.cancelAndSuspendFromWaitlist}
         onClick={cancelAndSuspendPatient}
      />
   );
};
